import { Component, OnInit } from '@angular/core';
import { Service } from 'src/app/service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  isShown: boolean = false;
  activatedRoute: any;
  questions;
  homePage: any;
  logo: any;
  description: any;
  startBtn: any;
  subTitle: any;
  title: any;
  advisors;
  advisorsList = [];
  advisor: any;
	public redirectTo: string;

  constructor(
    public quiz: Service,
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
  ) {

    this.changeLang(this.translate.currentLang);
    this.getAdvisors();
    
  }

  ngOnInit(): void {

  }

  getAdvisors(): void {
    this.quiz.getAdvisors()
      .subscribe(advisor => {
        this.advisors = advisor;

        this.getAdvisor();
      });

  }
  getAdvisor() {
    this.advisor = this.advisors;

    const name = this.route.snapshot.paramMap.get('name');
    //loop through questions
    for (var i = 0; i < this.advisor?.advisor.length; i++) {
      this.advisorsList[i] = this.advisor.advisor[i];
    }

    this.advisor = this.advisorsList.filter(
      x => x.name === name);

      if (this.advisor == undefined) {
      this.router.navigate(['/pageNotFound']);
      return;
    }

  }

  startAssessment() {
    if (this.advisor[0].name === undefined) {
      this.router.navigate(['/pageNotFound']);

    }
    else {
      this.router.navigate(['/advisor', this.advisor[0].name, 'question', '0']);
    }
  }
  changeLang(lang: string) {
    this.quiz.changeLang(lang);

    if (lang === "en") {
      this.quiz.getQuestions()
        .subscribe(questions => {
          this.questions = questions;
          this.logo = this.questions.homePage[0].FRLOGO;
          this.description = this.questions.homePage[0].description;
          this.startBtn = this.questions.homePage[0].startBtn;
          this.subTitle = this.questions.homePage[0].subTitle;
          this.title = this.questions.homePage[0].title;
        }
        );
    }
    else { 
      this.quiz.getQuestions()
        .subscribe(questions => {
          this.questions = questions;
          this.logo = this.questions.homePage[0].FRLOGO;
          this.description = this.questions.homePage[0].description;
          this.startBtn = this.questions.homePage[0].startBtn;
          this.subTitle = this.questions.homePage[0].subTitle;
          this.title = this.questions.homePage[0].title;
        }

        );

    }


  }

}